module.exports = __webpack_public_path__ + "static/img/302.cea902b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/210427/302.jpg
// module id = XTqG
// module chunks = 0